import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import { useEffect, useState } from "react";
import { IMajorTech } from "../../models/MajorTech";
import { IModel } from "./MajorTech";
import { Search } from "../../shared/Search";
import { Fetch } from "../../shared/Fetch";
import React from 'react';
import { EmptyMajorTech } from "./EmptyMajorTech";
import { ILogin, IPermissionProps } from "../../models/Login";
import { AutoAllocateHistory } from "./AutoAllocateHistory";
import { AutoTeamAllocateHistory } from "./AutoTeamAllocateHistory";
import { Dialog } from "primereact/dialog";
import { AutoAllocateForm } from "./SubCategory";
import { format } from "date-fns";
import { UserPerForm } from "./UserByPercAssign";
import { safeFormatDate } from "../../models/DateFormatMapper";


interface Iprops {
    open: boolean | undefined;
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps
}



export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IMajorTech>, loading: boolean });
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const [allocateHistory, setAllocateHistory] = useState({ singledata: {}, open: false } as { singledata: IMajorTech, open: boolean });
    const [allocateHistory1, setAllocateHistory1] = useState({ singledata: {}, open: false } as { singledata: IMajorTech, open: boolean });
    const [openTable1, setOpenTable] = useState(false);
    const [openForm, setOpenForm] = useState({ singledata: {}, open: false } as { singledata: IMajorTech, open: boolean });
    const [openUserPercenetage, setopenUserPercenetage] = useState({ singledata: {}, open: false } as { singledata: IMajorTech, open: boolean });



    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    useEffect(() => {
        loadTableData();
    }, [globalFilter, props.reload]);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Requirement_CateGoryLInfo", "GET", null, `search=${globalFilter}`, props.toast);
        if (response) {
            const data: Array<IMajorTech> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyMajorTech });
    };


    const openEdit = (rowDatauser: IMajorTech) => {

        props.setModal({ open: true, singleData: rowDatauser });
    };

    const openHistory = (rowDatauser: IMajorTech) => {
        setAllocateHistory({ singledata: rowDatauser, open: true });

    }
    const openHistory1 = (rowDatauser: IMajorTech) => {
        setAllocateHistory1({ singledata: rowDatauser, open: true });
    }

    const openAllocationForm = (rowDatauser: IMajorTech) => {
        setOpenForm({ singledata: rowDatauser, open: true });
    }
    const openUserPerForm = (rowDatauser: IMajorTech) => {
        console.log(rowDatauser)
        setopenUserPercenetage({ singledata: rowDatauser, open: true });
    }

    const hideHistory = () => {
        setAllocateHistory({ singledata: {}, open: false });
        setAllocateHistory1({ singledata: {}, open: false });
        setOpenForm({ singledata: {}, open: false });
        setopenUserPercenetage({ singledata: {}, open: false });
    }

    const leftToolbarTemplate = () => {

        return (
            <React.Fragment>
                {props.permissions.is_Create ? <div className="my-2">
                    {props.permissions.is_Create && <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />}
                </div> : <div></div>}
            </React.Fragment>
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0"> Major Technology</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span>
        </div>
    );


    const actionBodyTemplate = (rowData: IMajorTech) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil text-primary" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
                {(_roles.includes(1) || _roles.includes(26) || _roles.includes(4)) && rowData.recruiterAllocationAuto && <Button icon="pi pi-users text-primary" className="p-button-rounded p-button-success p-button-text mr-2" onClick={() => openHistory(rowData)} />}
                {rowData.allocateByTeamLead && (<Button icon="pi pi-users" className="p-button-rounded p-button-success bg-primary mr-1" onClick={() => openHistory1(rowData)} />)}
                {rowData.sub_Category && <Button icon="pi pi-plus" className="p-button-rounded p-button-success bg-primary mr-1" onClick={() => openAllocationForm(rowData)} />}
                {rowData.parent_ID == null && rowData.req_CategoryStatus == true && <Button icon="pi pi-dollar" className="p-button-rounded p-button-success bg-primary mr-1" onClick={() => openUserPerForm(rowData)} />}

            </div>
        );
    };

    const DateFormat = loginObj?.date_Format;

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} ></Toolbar>
            {props.permissions.is_View && <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                value={tableData.tableData}
                emptyMessage="No Data found."
                header={header}
                loading={tableData.loading}
            >
                <Column field="req_CategoryName" header="Major Technolgy" />
                <Column field="req_CategoryDescription" header="Description" />
                {/* <Column field="created_at" header="Created Date" body={(rowData) => <p>{rowData.created_at ? format(new Date(rowData.created_at), 'dd/MM/yyyy hh:mm a').toUpperCase().split(" ")[0] : ""}</p>} /> */}
                <Column field="created_at" header="Created Date" sortable body={(rowData: any) => safeFormatDate( rowData.created_at, "dd/MM/yyyy", DateFormat)} />
                <Column field="user_Name" header="Created By" />
                {props.permissions.is_Update && <Column body={actionBodyTemplate} />}
            </DataTable>}
            {props.permissions.is_View && <AutoAllocateHistory permissions={props.permissions} open={allocateHistory.open} singledata={allocateHistory.singledata} hideHistory={hideHistory} toast={props.toast} />}
            <AutoTeamAllocateHistory permissions={props.permissions} open={allocateHistory1.open} hideHistory={hideHistory} singledata={allocateHistory1.singledata} toast={props.toast} />
            {/* <Dialog header="Auto Team Allocate Table" style={{ width: '80vw' }} visible={openTable1} onHide={() => setOpenTable(false)} modal className="p-fluid">
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    size="small"
                >
                    <Column field="title" header="Title" />
                    <Column field="created_By" header="Created By" />
                    <Column field="created_On" header="Created On" />

                </DataTable>
                <div className="field col-12 md:col-6 w-full">
                    <Button className="p-button-outlined" label="CLOSE" onClick={() => setOpenTable(false)} type="button"></Button>
                </div>
            </Dialog> */}
            <AutoAllocateForm permissions={props.permissions} open={openForm.open} singledata={openForm.singledata} toast={props.toast} hideHistory={hideHistory} />
            <UserPerForm permissions={props.permissions} open={openUserPercenetage.open} singledata={openUserPercenetage.singledata} toast={props.toast} hideHistory={hideHistory} />

        </>
    );
}
